<template>
  <div style='position: relative;'>
    <a href='#' class='button button--secondary' v-if='isShown == false' @click.prevent.stop="isShown = true">Set Expiration Date</a>
    <transition name='popopen'>
      <div class='duplicator' v-if='isShown'>
        <span><b>Choose an expiration date</b></span>
        <slot></slot>
        <a href='#' class='button button--secondary' @click.prevent.stop="isShown = false">Cancel</a>
      </div>
    </transition>
  </div>
</template>

<script>


export default {
  props: [],
  data () {
    return {
      isShown: false
    }
  },
  methods: {
    
  },

}
</script>

